import { Helmet } from "react-helmet-async";
import { useLang } from "@/lib/i18n";
import { SITE_URL } from "@/lib/api";

const KEYWORDS =
  "houses for sale, homes for sale, land for sale, lots for sale, equestrian, horse tours, places to stay, pickleball, resort, retreats, new gated community, yankee beach, playa yankee, playa escamequita, san juan del sur, nicaragua, escamequita";

export const Seo = ({ title, description, image, jsonLd, noindex }) => {
  const { lang, basePath, pathFor } = useLang();
  const abs = (p) => `${SITE_URL}${p}`;
  const url = abs(pathFor(lang));
  const full = title ? `${title}` : "Escamequita | Homes, Land & Places to Stay near San Juan del Sur, Nicaragua";
  const img = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : `${SITE_URL}/media/hero.jpg`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={KEYWORDS} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="en" href={abs(basePath)} />
      <link rel="alternate" hrefLang="es" href={abs(pathFor("es"))} />
      <link rel="alternate" hrefLang="x-default" href={abs(basePath)} />
      <meta property="og:locale" content={lang === "es" ? "es_NI" : "en_US"} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Escamequita" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
